import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    DistrictDetails:{},
}

const DistrictDetailSlice = createSlice({
    name: "DistrictDetailSlice",
    initialState,

    reducers: {
        DistrictDetailsData(state, action) {
            return {
                DistrictDetails: action.payload.DistrictDetails,
            };
        }
    }
})
export const { DistrictDetailsData } = DistrictDetailSlice.actions;
export default DistrictDetailSlice.reducer;